import { Component } from "react";
import { useState } from "@discovery/common-dplus/lib/hooks";
import { detectAdblock } from "../../../utils/adBlocker";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
import * as styles from "./styles.css";
export class OutofPage extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            display: false,
        };
        this.componentDidMount = () => {
            googletag.cmd.push(() => {
                const w = window.innerWidth;
                let s2 = "";
                if (w > 1024) {
                    s2 = "web";
                }
                else if (w <= 1024 && w >= 728) {
                    s2 = "tablet";
                }
                else {
                    s2 = "mobile";
                }
                googletag
                    .defineOutOfPageSlot("/21712083437/dplus/" + `${s2}/home/landing` + "/out_of_page", "oop_slot")
                    .addService(googletag.pubads());
            });
            this.setState({ display: true });
            this.isAdRendered();
        };
        this.isAdRendered = () => {
            googletag.cmd.push(() => {
                googletag.pubads().addEventListener("slotRenderEnded", (event) => {
                    // Log details of the rendered ad.
                    if (!event.isEmpty) {
                        try {
                            localStorage.setItem("isValidTrigger", JSON.stringify(false));
                            localStorage.setItem("adDisplayed", JSON.stringify(true));
                        }
                        catch (e) {
                            console.info(e);
                        }
                    }
                });
            });
        };
        this.popTriggerpoints = () => {
            let events;
            try {
                events = localStorage.getItem("events");
            }
            catch (e) {
                events = null;
            }
            const localRepoItems = events;
            const newArray = localRepoItems ? JSON.parse(localRepoItems) : [];
            if (newArray.length > 3) {
                const list = newArray.slice(0, 1);
                try {
                    localStorage.setItem("events", JSON.stringify(list));
                }
                catch (e) {
                    console.info(e);
                }
            }
            return;
        };
        this.componentWillUnmount = () => {
            googletag.cmd.push(() => {
                googletag.destroySlots();
            });
        };
    }
    render() {
        const isHome = window.location.pathname === "/" ||
            window.location.pathname === config.standardPageRouteFragments.home
            ? styles.wrapper
            : "";
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { id: "oop_slot", className: isHome },
                React.createElement("script", null, googletag.cmd.push(() => {
                    googletag.display("oop_slot");
                }))),
            this.popTriggerpoints()));
    }
}
const InterstitialsAds = () => {
    const [showAd, displayAd] = useState(false);
    const checkForAdBlocker = () => {
        detectAdblock().then((isDetected) => {
            displayAd(!isDetected);
        });
    };
    const renderAd = () => {
        return showAd && React.createElement(OutofPage, null);
    };
    return (React.createElement(React.Fragment, null,
        checkForAdBlocker(),
        renderAd()));
};
export default InterstitialsAds;

